import React, { useEffect, useState } from 'react';
import ReactEcharts from 'echarts-for-react';
import API from '../../../api';

const StatAvoir = () => {
    const [etatFacturationValues, setEtatFacturationValues] = useState({ facture_avoir: 0, totalFact: 0 });

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await API.post('facture/client/get_stat_facture');
                const data = response.data.FactureClient;
                setEtatFacturationValues({
                    facture_avoir: parseFloat(data.pourcentageAvoir),
                    totalFact: parseFloat(data.totalFact),
                });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchData();
    }, []);

    const getOptionFacturation = () => {
        return {
            toolbox: {
                show: false,
            },
            tooltip: {
                trigger: 'item',
                formatter: '{a} <br/>{b} : {c} ({d}%)',
            },
            legend: {
                orient: 'vertical',
                left: 10, // Adjust the left position as needed
                data: ['Factures Avoir', 'Total des factures'], // Update legend data
                textStyle: {
                    color: ['#74788d'],
                },
            },
            color: ['#02a499', '#f8b425', '#ec4561', '#38a4f8', '#3c4ccf'],
            series: [
                {
                    name: 'Total sales',
                    type: 'pie',
                    radius: '55%',
                    center: ['50%', '60%'],
                    data: [
                        { value: etatFacturationValues.facture_avoir, name: 'Factures Avoir' },
                        { value: etatFacturationValues.totalFact - etatFacturationValues.facture_avoir, name: 'Total des factures' },
                    ],
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)',
                        },
                    },
                },
            ],
        };
    };

    return (
        <React.Fragment>
            <p>Facture Avoir</p>
            <ReactEcharts style={{ height: '350px' }} option={getOptionFacturation()} />
        </React.Fragment>
    );
};

export default StatAvoir;
